import { render } from "./CustomerTrimStats.vue?vue&type=template&id=4bfce3b0&scoped=true"
import script from "./CustomerTrimStats.vue?vue&type=script&lang=js"
export * from "./CustomerTrimStats.vue?vue&type=script&lang=js"

import "./CustomerTrimStats.vue?vue&type=style&index=0&id=4bfce3b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bfce3b0"]])

export default __exports__